export default {
	PENDING: 'pending',
	COMPLETED: 'completed',
	DISABLED: 'disabled',
}
